import { GetUsersPreferencesUnitsStatus200 } from "@imi/api-client/index.js";
import { mapEntries, set } from "radashi";
import { z } from "zod/v4";
import { unitsRepository } from "../engine/units/unitsRepository";

const unitOptions = unitsRepository.getOptions();

export type UnitsPreferences = z.infer<typeof unitsPreferencesSchema>;
export type UnitType = keyof typeof unitOptions;

export const unitsPreferencesSchema = z.object({
  ...mapEntries(unitOptions, (key, value) => [
    key,
    z
      .string()
      .nullable()
      .refine(
        (val) => value.options.some((option) => !val || option.id === val),
        { message: `Invalid unit for ${key}` },
      ),
  ]),
});

export function buildUnitsPreferences(
  units: GetUsersPreferencesUnitsStatus200 | null,
): UnitsPreferences {
  if (!units) return {} as UnitsPreferences;
  return units?.reduce(
    (acc, unit) => set(acc, unit.type, unit.value),
    {} as UnitsPreferences,
  );
}
